import React from 'react';
import { usePermissions } from '@pankod/refine-core';
import { IResourceComponentsProps } from '@pankod/refine-core';
import {
  List,
  DateField,
  Table,
  useTable,
  EditButton,
  ShowButton,
  DeleteButton,
  Space,
  TagField,
} from '@pankod/refine-antd';

import { LeadTypes } from 'interfaces';
import { USER_ROLES } from 'constant';

const LeadList: React.FC<IResourceComponentsProps> = () => {
  const { data: permissionsData } = usePermissions();
  const { tableProps } = useTable<LeadTypes>({
    initialSorter: [
      {
        field: 'name',
        order: 'desc',
      },
    ],
    metaData: {
      fields: [
        'id',
        'source',
        'note',
        'name',
        'email',
        'phone',
        'country',
        'company',
        'message',
        'performed_by',
        'status',
        'updated_by',
        'createdAt',
      ],
    },
  });

  return (
    <List>
      <Table {...tableProps} rowKey='id'>
        {/* <Table.Column
          key='performed_by'
          dataIndex='performed_by'
          title='Lead By'
        /> */}

        <Table.Column
          key='source'
          dataIndex='source'
          title='Source'
          render={(source) => <TagField value={source} />}
        />
        <Table.Column key='name' dataIndex='name' title='Name' />
        <Table.Column key='email' dataIndex='email' title='Email' />
        <Table.Column key='phone' dataIndex='phone' title='Phone' />
        <Table.Column key='country' dataIndex='country' title='Country' />
        <Table.Column key='company' dataIndex='company' title='Company' />
        <Table.Column
          key='status'
          dataIndex='status'
          title='Status'
          render={(status) => <TagField value={status} />}
        />

        <Table.Column
          dataIndex='createdAt'
          title='CreatedAt'
          render={(createdAt) => <DateField format='LL' value={createdAt} />}
        />

        <Table.Column
          key='updated_by'
          dataIndex='updated_by'
          title='Updated By'
        />

        <Table.Column<LeadTypes>
          title='Actions'
          dataIndex='actions'
          render={(_, record) => (
            <Space>
              <EditButton hideText size='small' recordItemId={record.id} />

              <ShowButton hideText size='small' recordItemId={record.id} />
              {permissionsData?.role === USER_ROLES.SUPER_ADMIN && (
                <DeleteButton hideText size='small' recordItemId={record.id} />
              )}
            </Space>
          )}
        />
      </Table>
    </List>
  );
};

export default LeadList;
